package kz.dentalcrm.app.screens.splash.mvi

data class SplashViewState(
    val isChecking: Boolean = true,
)
